import React from 'react';
import { Box, CircularProgress, Typography } from '@mui/material';

interface LoadingScreenProps {
  message?: string;
}

/**
 * Ekran ładowania wyświetlany podczas weryfikacji tokenów uwierzytelniających
 */
const LoadingScreen: React.FC<LoadingScreenProps> = ({ message = 'Trwa ładowanie...' }) => {
  return (
    <Box
      sx={{
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        height: '100vh',
        width: '100%',
        backgroundColor: '#f5f5f5',
      }}
    >
      <CircularProgress size={60} thickness={4} />
      <Typography variant="h6" sx={{ mt: 2 }}>
        {message}
      </Typography>
      <Typography variant="body2" color="text.secondary" sx={{ mt: 1 }}>
        Weryfikacja sesji użytkownika...
      </Typography>
    </Box>
  );
};

export default LoadingScreen;
